import Journey from "./journey"

export default Journey
